import Vue from 'vue'
import Router from 'vue-router'
import layout from './layout'
import layoutCms from './layout_cms'

Vue.use(Router)

const _import = require('./_import_' + process.env.NODE_ENV)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/loading',
      name: 'loading',
      component: _import('loading'),
      meta: {
        permission: false,
        allowBack: false,
        noCache: true
      }
    },
    {
      path: '/importVideo', // 单视频 引导视频
      name: 'importVideo',
      component: _import('importVideo'),
      meta: {
        permission: true,
        allowBack: false,
        noCache: true
      }
    },
    {
      path: '/result', // 单个知识点结果
      name: 'result',
      component: _import('result/index'),
      meta: {
        permission: true,
        allowBack: false,
        noCache: true
      }
    },
    {
      path: '/knowledge', // 单个知识点结果
      name: 'knowledge',
      component: _import('knowledge/index'),
      meta: {
        permission: true,
        allowBack: false,
        noCache: true
      }
    },
    {
      path: '/target', // 过渡页
      name: 'target',
      component: _import('target'),
      meta: {
        permission: true,
        allowBack: false,
        noCache: true
      }
    },
    {
      path: '*',
      component: _import('notFound'),
    },
    layout,
    layoutCms,
    {
      path: '/report', //报告页
      name: 'report',
      component: _import('report/index'),
      meta: {
        permission: false,
        allowBack: true,
        noCache: true
      }
    },
    {
      path: '/allquestion', //详情页
      name: 'allquestion',
      component: _import('allquestion/index'),
      meta: {
        permission: false,
        allowBack: true,
        noCache: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js